import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const carouselSwiper = new Swiper( '.carousel-swiper__wrapper', {
  slidesPerView: 1.2,
  slidesPerGroup: 1,
  spaceBetween: 32,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    }
  }
} );
